// extracted by mini-css-extract-plugin
export default {"warning-text":"DeleteFormModal_warning-text__ChZH3","info-text":"DeleteFormModal_info-text__EtXGx","button-container":"DeleteFormModal_button-container__t83dE"};